<div class="flex flex-col w-full h-full overflow-hidden">
  <div class="flex-1 min-h-0 p-0 relative overflow-hidden">
    <div
      [ngClass]="{
        'fixed w-[70vw] h-[50vh] top-0 left-1/2 -translate-x-1/2 theme-bg-1--opacity':
          pinImg,
        'flex flex-col w-full h-full overflow-hidden relative group': !pinImg,
      }"
    >
      @if (movementArrows) {
        <button
          (click)="imgMovement.emit('previous'); $event.stopPropagation()"
          mat-mini-fab
          color="primary"
          class="material-icons round-btn !absolute !top-1/2 !-translate-y-1/2 !left-2 opacity-0 !transition-opacity !duration-300 !ease-out group-hover:!opacity-100 !z-20 pointer-events-auto"
          aria-label="Previous image"
          [disabled]="
            movementDisabled === 'previous' || movementDisabled === 'both'
          "
        >
          arrow_back
        </button>

        <button
          (click)="imgMovement.emit('next'); $event.stopPropagation()"
          mat-mini-fab
          color="primary"
          class="material-icons round-btn !absolute !top-1/2 !-translate-y-1/2 !right-2 !opacity-0 transition-opacity !duration-300 !ease-out group-hover:!opacity-100 !z-20 pointer-events-auto"
          aria-label="Next image"
          [disabled]="
            movementDisabled === 'next' || movementDisabled === 'both'
          "
        >
          arrow_forward
        </button>
      }
      @if (zoomImg) {
        <phoenix-simple-zoom
          class="h-full w-full overflow-hidden"
          [imgUrl]="img"
          [altText]="altText"
          [lensWidth]="lensWidth + boxExtraSize"
          [lensHeight]="lensHeight + boxExtraSize"
          [enableLens]="true"
          [magnification]="2 + boxExtraSize / 100"
          [maxZoomRatio]="4 + boxExtraSize / 100"
        ></phoenix-simple-zoom>
      } @else {
        <div class="relative flex items-center justify-center w-full h-full">
          <img
            class="max-w-full max-h-full w-auto h-auto object-contain"
            [src]="img"
            [alt]="altText"
            (click)="clickImage.emit()"
            (keyup)="(null)"
            (error)="onImageLoadError($event)"
          />
        </div>
      }
    </div>

    <div
      [ngClass]="{
        'material-icons-outlined fixed top-[10px] left-[75%]': pinImg,
        'absolute top-0 right-0': !pinImg,
      }"
      class="flex flex-row justify-between"
    >
      @if (deleteButton) {
        <button
          name="imgViewerDeleteButton"
          mat-icon-button
          type="button"
          class="material-icons-outlined"
          (click)="delete()"
          color="warn"
          matTooltip="Remove image"
        >
          remove_circle_outline
        </button>
      }
      @if (staticImg) {
        <button
          name="imgViewerPinButton"
          mat-icon-button
          type="button"
          class="material-icons"
          [ngClass]="{
            'material-icons-outlined': pinImg,
          }"
          (click)="pinImg = !pinImg"
          [matTooltip]="!pinImg ? 'Pin image to the top' : 'Unpin image'"
        >
          push_pin
        </button>
      }
    </div>
  </div>
  @if (imgActions) {
    <phoenix-img-actions
      class="theme-bg-1"
      [img]="img"
      [imgDownload]="imgDownload"
      [uploadButton]="uploadButton"
      [zoomImg]="zoomImg"
      [centerDivs]="centerDivs"
      [(boxExtraSize)]="boxExtraSize"
      (selectedFile)="uploadImgs($event)"
    ></phoenix-img-actions>
  }
</div>
